<template>
    <div>
        <el-tabs type="border-card" class="demo-tabs">
            <el-tab-pane label="Thông tin chung">
                <div class="row">
                    <div class="col-xl-6">
                        <identification-information :dataInfo="identityCard"></identification-information>
                    </div>
                    <div class="col-xl-6">
                        <information-genneral :dataInfo="personalInformation"></information-genneral>
                        <edutalk-brank :userBank="userBank" :hideProvince="hideProvince" :updated_at="updated_at"></edutalk-brank>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="Thông tin làm việc chung">
                <general-working-info :dataGeneralWorking="dataGeneralWorking"></general-working-info>
            </el-tab-pane>
            <el-tab-pane label="Hợp đồng">
                <manager-contracts-folder></manager-contracts-folder>
            </el-tab-pane>
            <el-tab-pane label="Quá trình làm việc">
                <working-process :dataWorking="dataWorking"></working-process>
            </el-tab-pane>
            <el-tab-pane label="Khung năng lực">Task</el-tab-pane>
            <el-tab-pane label="Phúc lợi">
                <welfare></welfare>
            </el-tab-pane>
            <el-tab-pane label="KPI">
                <kpi-staff></kpi-staff>
            </el-tab-pane>
            <el-tab-pane label="Ảnh và hồ sơ đính kèm">
                <photos-and-documents></photos-and-documents>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import IdentificationInformation from "./Component/IdentificationInformation";
import InformationGenneral from "./Component/InformationGenneral";
import EdutalkBrank from "./Component/EdutalkBrank";
import {GENERAL_WORKING_INFO, GET_GENERAL_INFO, GET_WORKING_PROCESS} from "../../../core/services/store/profile.module";
import GeneralWorkingInfo from "./Component/GeneralWorkingInfo";
import ManagerContractsFolder from "./Component/ManagerContractsFolder";
import WorkingProcess from "./Component/WorkingProcess";
import Welfare from "./Component/Welfare";
import KpiStaff from "./Component/KpiStaff";
import PhotosAndDocuments from "./Component/PhotosAndDocuments";
import moment from "moment";
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";

export default {
    name: "UserInformation",
    components: {
        IdentificationInformation,
        InformationGenneral,
        EdutalkBrank,
        GeneralWorkingInfo,
        ManagerContractsFolder,
        WorkingProcess,
        Welfare,
        KpiStaff,
        PhotosAndDocuments
    },
    data()
    {
        return {
            identityCard: {
                id: "",
                id_number: "",
                full_name: "",
                date_of_birth: "",
                gender: "",
                nationality: "",
                place_of_origin: "",
                place_of_residence: "",
                expiry_date: "",
                issued_date: "",
                issued_place: ""
            },
            personalInformation: {
                id: '',
                phone: '',
                phone_other: '',
                email: '',
                internal_email: '',
                address: '',
                social_insurance_number: '',
                education_level: '',
                university: '',
                major: '',
            },
            dataGeneralWorking: {
                start_date: '',
                probation_months: '',
                probation_end_date: '',
                official_start_date: '',
                income_scheme: '',
                equity_start_date: '',
                salary: '',
                start_to_work: '',
                salary_social_insurance: '',
                division_type: '',
            },
            dataWorking: [],
            userId: this.$route.query.user_id,
            userBank: {
                chi_nhanh: "",
                ngan_hang: "",
                stk: "",
                province: "",
                owner_name: "",
                updated_at: "",
            },
            hideProvince: false,
            updated_at: '',
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
          {title: "Thông tin nhân sự"},
          {title: "Danh sách nhân sự"}
        ]);
        this.getInformationUser();
        this.getGeneralWorking();
        this.getWorking();
    },
    methods: {
        getInformationUser()
        {
            this.$store.dispatch(GET_GENERAL_INFO, {id: this.userId}).then((res) => {
                let data = res.data;

                this.identityCard = {
                    id: this.userId,
                    full_name: data?.identity_card?.full_name ?? '',
                    id_number: data?.identity_card?.id_number ?? '',
                    date_of_birth: data?.identity_card?.date_of_birth ?? '',
                    gender: data?.identity_card?.gender ?? '',
                    place_of_origin: data?.identity_card?.place_of_origin ?? '',
                    issued_date: data?.identity_card?.issued_date ?? '',
                    expiry_date: data?.identity_card?.expiry_date ?? '',
                    issued_place: data?.identity_card?.issued_place ?? '',
                    nationality: data?.identity_card?.nationality ?? '',
                    place_of_residence: data?.identity_card?.place_of_residence ?? '',
                }

                this.personalInformation = {
                    id: this.$route.query.user_id,
                    phone: data?.phone ?? '',
                    phone_other: data?.phone_other ?? '',
                    gender: data?.profile?.gender ?? '',
                    email: data?.email ?? '',
                    address: data?.profile?.address ?? '',
                    internal_email: data?.personal_information?.internal_email ?? '',
                    social_insurance_number: data?.personal_information?.social_insurance_number ?? '',
                    education_level: data?.personal_information?.education_level ?? '',
                    university: data?.personal_information?.university ?? '',
                    major: data?.personal_information?.major ?? '',
                }

                let userBank = data?.bank_accounts ? data?.bank_accounts[0] : '';
                if (!userBank)
                {
                    return;
                }
                this.userBank = userBank;
                moment.locale("vi"); // đổi toàn cục sang tiếng Việt
                this.updated_at = moment(this.userBank.updated_at, 'YYYY-MM-DD HH:mm:ss').fromNow();
                console.log(this.updated_at, 'this.userBank.updated_at')
                if (this.userBank.ngan_hang === 'Agribank') {
                    this.hideProvince = true;
                }
            });
        },
        getGeneralWorking()
        {
            this.$store.dispatch(GENERAL_WORKING_INFO, this.userId).then((res) => {
                if (res.data)
                {
                    this.dataGeneralWorking = {
                        start_date: new Date(res.data.start_date),
                        probation_months: res.data.probation_months,
                        probation_end_date: new Date(res.data.probation_end_date),
                        official_start_date: new Date(res.data.official_start_date),
                        income_scheme: res.data.income_scheme,
                        equity_start_date:res.data.equity_start_date ?  new Date(res.data.equity_start_date)  : '',
                        salary: res.data.salary,
                        start_to_work: res.data.start_to_work ? new Date(res.data.start_to_work) : '',
                        salary_social_insurance: res.data.salary_social_insurance,
                        check_in_time: res.data.check_in_time,
                        check_out_time: res.data.check_out_time,
                        work_calendar: res.data.work_calendar,
                    };
                }
            });
        },
        getWorking()
        {
            this.$store.dispatch(GET_WORKING_PROCESS, this.userId).then((res) => {
                this.dataWorking = res.data;
            });
        },
    },
}
</script>

<style scoped>
    .bg-violet {
        background-color: #5E00B6;
    }
</style>